import type React from 'react';

import {useInteractAnywhere} from '../hooks/useInteractAnywhere';

import {useUiConfig} from '../providers/UiConfigProvider';
import {usePartialIframe} from './OverlayOverrides';
import type {PopoverInternalProps} from '../components/popover/utils';

export const usePopoverIframe = (props: PopoverInternalProps) => {
  const uiConfig = useUiConfig();
  const getUILayers = uiConfig?._unstable_getUILayers;

  const handleClose = (event: React.SyntheticEvent) => {
    if (
      event.target !== props.targetRef.current &&
      !props.targetRef.current?.contains(event.target as Node)
    ) {
      props.onOpenChange(false);
    }
  };
  useInteractAnywhere(handleClose, props.targetRef.current?.ownerDocument);

  return usePartialIframe({
    ...props,
    onClose: () => props.onOpenChange(false),
    uiLayers: getUILayers ? getUILayers() : [],
  });
};
